import { useParams } from "react-router-dom";
import {React, useState,useEffect} from 'react';
import {Api} from '../component/api';
import HtmlContent from '../component/HtmlContent';
import PageTitle from "../component/pageTitle";
import FreeShipping from "../component/freeshipping";



function Content()
{
    const { id } = useParams();
    const contentId = id.split("-")[0];
    const [loading, setLoading] = useState(false); 
    const [data, setData] = useState({});
    async function fetchData(contentId) {

        if(!contentId)
        {
            return;
        }
        setLoading(true);
        try {
            const response = await Api("content",{id_cms: contentId});
            if(response.success==true){
                setData(response.psdata.cmsVar);
                //setData(response.psdata);
            }
        } catch (error) {
            console.error("API Error:", error);
        } 
        finally {
            setLoading(false); // پایان بارگذاری
        }
    }
    useEffect(() => {
        fetchData(contentId);
    }, [contentId]);

    return(
        <>
            <PageTitle title={data.meta_title}/>
            <div className="container">
            <HtmlContent content={data.content} />
            </div>
            <FreeShipping />
        </>
    );
}
export default Content;